module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <label>On click Action Type:\n        <select class="actions-select" id="action-type"></select>\n    </label>\n</div>\n<div class="action-region"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/ActionsView.tpl
// module id = 1720
// module chunks = 0